export default "__VITE_ASSET__KAm0ZkAE__"